import { Menu } from 'antd';
import React from 'react'

const CommonSidebar = ({handleChangeSideMenu, sideMenuItems, Sider, theme, activeKey, HeaderContentChildren = null}) => {
  return (
    <Sider width={256} align={"center"} style={{ backgroundColor: theme === "light" ? "#fff" : "#000", borderRight: "1px solid var(--border-color)", padding: "15px", marginBottom: "55px" }} >
    {
      HeaderContentChildren ? <div className="side-top-section">{HeaderContentChildren}</div> : <></>
    }

    <div className="knowledge-base-sidemenu">
      <Menu
        onClick={handleChangeSideMenu}
        style={{
          width: "100%",
          border: "none",
          textAlign: "start",
          backgroundColor: "transparent",
          display: "flex",
          flexDirection: "column",
        }}
        defaultSelectedKeys={[activeKey]}
        defaultOpenKeys={['sub1']}
        mode="inline"
        items={sideMenuItems}
        selectedKeys={[activeKey]}
        iconSize={20}
      />
    </div>
  </Sider>
  )
}

export default CommonSidebar